var exports = {
  "n": "x112a1f60--244e8c--link",
};

module.exports = exports;
